import projects from "./pageTexts/projects"

export default (id) => {
    return projects.findIndex((e) => e.id == id);
}